import { MinzeElement } from 'minze'

export interface LvcRedXIcon {}

export class LvcRedXIcon extends MinzeElement {
  html = () => `
  <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 9C6.72234 7.77224 5.49206 6.47963 4.31317 5.1268M4.31317 5.1268C3.16768 3.81229 2.04474 2.42401 1 1M4.31317 5.1268C5.39654 3.6513 6.68118 2.41964 8 1M4.31317 5.1268C3.06821 6.63983 2.15598 7.52691 1 9" stroke="#FF4600" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

  
  `

  css = () => `
    
  `
}
